import { PettyCash } from "../PettyCash/PettyCash.type";
import { Replenishment } from "../Replenishment/Replenishment.type";
import { User } from "../User/User.type";
import { ApiCallState } from "../Utils";

export type ReplenishmentRequest = {
  id: number;
  user_id: number;
  petty_cash_id: number;
  replenishment_of_id: number;

  request_number: string;
  amount: number;

  prepared_by_id: number;
  checked_by_id: number;
  approved_by_id: number;

  is_checked: boolean;
  is_approved: boolean;

  is_replenished: boolean;
  date: Date;

  user: User;

  petty_cash: PettyCash;
  prepared_by: User;
  checked_by: User;
  approved_by: User;

  replenishment_of: Replenishment;

  readonly createdAt: Date;
  readonly updatedAt: Date;
};

export type ReplenishmentRequestStateTypes = {
  fetchAll: ApiCallState<ReplenishmentRequest[]>;
  fetchOne: ApiCallState<ReplenishmentRequest | {}>;
  fetchRequestNumber: ApiCallState<String | null>;
};

export const ReplenishmentRequestActionTypes = {
  FETCH_ALL_REPLENISHMENT_REQUEST: "FETCH_ALL_REPLENISHMENT_REQUEST",
  FETCH_ALL_REPLENISHMENT_REQUEST_RESET:
    "FETCH_ALL_REPLENISHMENT_REQUEST_RESET",
  FETCH_ALL_REPLENISHMENT_REQUEST_FAILURE:
    "FETCH_ALL_REPLENISHMENT_REQUEST_FAILURE",
  FETCH_ALL_REPLENISHMENT_REQUEST_SUCCESS:
    "FETCH_ALL_REPLENISHMENT_REQUEST_SUCCESS",

  FETCH_ONE_REPLENISHMENT_REQUEST: "FETCH_ONE_REPLENISHMENT_REQUEST",
  FETCH_ONE_REPLENISHMENT_REQUEST_RESET:
    "FETCH_ONE_REPLENISHMENT_REQUEST_RESET",
  FETCH_ONE_REPLENISHMENT_REQUEST_FAILURE:
    "FETCH_ONE_REPLENISHMENT_REQUEST_FAILURE",
  FETCH_ONE_REPLENISHMENT_REQUEST_SUCCESS:
    "FETCH_ONE_REPLENISHMENT_REQUEST_SUCCESS",

  FETCH_REPLENISHMENT_REQUEST_NUMBER: "FETCH_REPLENISHMENT_REQUEST_NUMBER",
  FETCH_REPLENISHMENT_REQUEST_NUMBER_RESET:
    "FETCH_REPLENISHMENT_REQUEST_NUMBER_RESET",
  FETCH_REPLENISHMENT_REQUEST_NUMBER_FAILURE:
    "FETCH_REPLENISHMENT_REQUEST_NUMBER_FAILURE",
  FETCH_REPLENISHMENT_REQUEST_NUMBER_SUCCESS:
    "FETCH_REPLENISHMENT_REQUEST_NUMBER_SUCCESS",
};
